import ChatInterfaceContainer from "@/components/Chat/chatInterfaceContainer.component";
import BasePage from "@/infrastructure/BasePage/basePage.component";
import React from "react";

type PageChatProps = {
  // TODO: add props here
};

const PageChat: React.FC<PageChatProps> = (props) => {
  return (
    <BasePage currPage="Chat">
      <div className="h-full w-full max-w-[100vw] overflow-hidden">
        <ChatInterfaceContainer />
      </div>
    </BasePage>
  );
};

export default PageChat;
